import * as Devices from '../../../modules/devices/model';
import * as Orders from '../../../modules/orders/model';
import * as DTypes from '../../../modules/devicetypes/model';
import * as Customers from '../../../modules/customers/model';
import { ErrorDataResponse } from './exceptions';
import { CustomerInfo } from '../../../models/common';
import { IDownloadLogData } from '../../../modules/dialogs/downloadLogs/model';
import { TransferDetails } from '../../../modules/dialogs/transfer/model';
import { IDownloadableCheck } from '../../../interfaces/iDownload';

export type MyKeysPromiseValue<T> = T | ErrorDataResponse;
export type MyKeysPromise<T> = Promise<MyKeysPromiseValue<T>>;

export interface PageRequest {
  pageIndex: number;
  pageSize: number;
}

export interface DatesRequest {
  from?: string;
  to?: string;
}

export type FilterCritria =
  | Devices.FilterCritria
  | Orders.FilterCriteria
  | DTypes.FilterCriteria
  | Customers.FilterCriteria;

export enum criterionNames {
  orderNumber = 'orderNumber',
  deviceName = 'deviceName',
  active = 'active',
  status = 'status',
  availability = 'availability',
  serialNumber = 'serialNumber',
  readRights = 'readRights',
  owner = 'owner',
  meterRangeStart = 'meterRangeStart',
  meterRangeEnd = 'meterRangeEnd',
  invoiceDate = 'invoiceDate',
  itemCount = 'itemCount',
  numDevices = 'numDevices',
  manufactureId = 'manufactureId',
  customerDeviceNo = 'customerDeviceNo',
  userOrders = 'userOrders',
  isActive = 'isActive',
  deviceStatus = 'deviceStatus',
  userWithReadRights = 'userWithReadRights',
  snLabel = 'snLabel',
}

export const SearchCriteriaDto = Object.freeze({
  [criterionNames.orderNumber]: 0,
  [criterionNames.deviceName]: 1,
  [criterionNames.active]: 2,
  [criterionNames.status]: 3,
  [criterionNames.availability]: 4,
  [criterionNames.serialNumber]: 5,
  [criterionNames.readRights]: 6,
  [criterionNames.owner]: 7,
  [criterionNames.meterRangeStart]: 8,
  [criterionNames.meterRangeEnd]: 9,
  [criterionNames.invoiceDate]: 10,
  [criterionNames.itemCount]: 11,
  [criterionNames.manufactureId]: 12,
  [criterionNames.customerDeviceNo]: 13,
  [criterionNames.userOrders]: 14,
  [criterionNames.snLabel]: 15,
});

export type SearchCriteriaDtoType = typeof SearchCriteriaDto;

export interface CriterionDto {
  criteriaType: SearchCriteriaDtoType | number;
  criteriaValue: string;
}

export interface CriteriaListDto {
  criteriaDtos: CriterionDto[];
  sortBy?: SearchCriteriaDtoType | number;
  sortDescending?: boolean;
}

export const CriteriaListDtoDefault: CriteriaListDto = {
  criteriaDtos: [],
  sortBy: 0,
  sortDescending: false,
};

// export type DownloadOptionsType = keyof typeof OptionsDto;

export interface HistoryDtos extends Devices.ILogData {
  eventTime: string;
}

export interface DeviceHistoryDto {
  totalCount: number;
  historyDtos: HistoryDtos[];
}

/*
export interface DeviceInfoDto extends DeviceInfo.Item {
  
}
*/
export interface DeviceInfoDto extends Devices.Device, Devices.DeviceExtension {
  longDeviceName: string;
  historyList: DeviceHistoryDto;
}
export type DeviceInfoRequest = Devices.PKey & PageRequest & DatesRequest;

export interface SetReadRightsRequest {
  criteria: CriteriaListDto;
  devices: Devices.PKey[];
  deviceLabels: string[];
  assigneeCustomerId?: string;
  assigneeCustomerName?: string;
}

/* ***************************** */

export interface DeviceListLineDto extends Devices.Device {
  showOrderNumber: boolean;
  customerDeviceNo: string;
}

export interface DeviceListDto extends Devices.Totals {
  deviceDtos: DeviceListLineDto[];
  totalCount: number;
}

export interface GroupDto extends Devices.Totals {
  description: string;
  itemCount: number;
  timestamp: Date;
  showGroupName: boolean;
}

export interface GroupListDto {
  totalCount: number;
  groupListDtos: GroupDto[];
}

export interface DeviceRegistrationResultsDto extends Devices.PKey {
  registrationSucceeded: boolean;
  serialNumberDoesNotExist: boolean;
  availabilityLevelNotSetToExtended: boolean;
  deviceAlreadyRegistered: boolean;
  serialNumberAndDeviceCodeDoesNotMatch: boolean;
  tooManyFailedRegistrationsForUser: boolean;
  deviceHasBeenLocked: boolean;
  assignedCustomerName: string;
}

export interface GetUserDetailsDto extends CustomerInfo {
  userId: string;
  userEmail: string;
  // customerId: string;
  customerDisplayName: string;
  // customerName: string;
}

export interface DownloadableCheckDto extends IDownloadableCheck {
  Name: string;
  ContentType: string;
  Stream: string;
}


export interface DownloadLogDto extends IDownloadLogData {
  created: string;
}

export interface DownloadHistoryDto {
  totalCount: number;
  downloadHistoryDtos: DownloadLogDto[];
}

export interface DeviceSettingsDto {
  deviceTypes: string[];
}

export type TransferDto = TransferDetails;

export interface TransferHistoryDto {
  totalCount: number;
  transferDtos: TransferDto[];
}
